const SignatureTypeValues = {
  DIGITAL: 'DIGITAL',
  PHYSICAL: 'PHYSICAL',
} as const;

export type SignatureType =
  (typeof SignatureTypeValues)[keyof typeof SignatureTypeValues];

export const getSignatureTypeLabel = (value: SignatureType) => {
  switch (value) {
    case 'DIGITAL':
      return $localize`digital`;
    case 'PHYSICAL':
      return $localize`physique`;
  }
};
